import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: '1rem 1rem 1rem',
      borderBottom: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
    },
    eyebrow: {
      fontSize: '0.70rem',
      fontWeight: 700,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      color: theme.palette.primary.main,
      marginBottom: 4,
    },
    title: {
      fontSize: '1.6rem',
      fontWeight: 700,
      color: theme.palette.text.primary,
      lineHeight: 1.2,
    },
    subtitle: {
      marginTop: 4,
      color: theme.palette.text.secondary,
      fontSize: '0.9rem',
    },
  }),
);

interface PageTitleProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
}

export function PageTitle({ eyebrow, title, subtitle }: PageTitleProps) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {eyebrow && <Typography className={classes.eyebrow}>{eyebrow}</Typography>}
      <Typography className={classes.title}>{title}</Typography>
      {subtitle && <Typography className={classes.subtitle}>{subtitle}</Typography>}
    </div>
  );
}
